<template>
  <Teleport :to="to">
    <transition
      name="bounce"
      appear
    >
      <div
        class="popup-info"
        :style="styleCustom"
        @mouseleave="$emit('close')"
      >
        <div class="popup-info__body">
          <div class="popup-info__text">{{text}}</div>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script>

import Teleport from 'vue2-teleport';

export default {
  name: 'PopupInfo',
  components: {
    Teleport,
  },
  props: {
    styleCustom: {
      type: Object,
      default: () => ({}),
    },
    to: {
      type: String,
      default: '#app',
    },
    text: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../sass/variables";

.popup-info {
  position: fixed;
  background-color: $color-white;
  z-index: 999;

  &__body {
    font-family: $global-font;
    padding: 7px;
    background-color: rgba($color-black, 0.6);
    color: $color-white;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 6px;
    font-weight: 400;
    font-size: 12px;
  }

  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 21px;
    height: 21px;
    border-radius: 50%;
    color: $color-denim;
    background-color: $color-wild-sand;
    cursor: pointer;

    &_remove {
      color: $color-pomegranate;
    }
  }

  &__text {
    white-space: pre-wrap;
    word-break: break-all;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/PopupInfo/PopupInfo.vue